module.exports = __webpack_public_path__ + "static/media/phone_3.f423f8dd.png";